var BackboneEvents = require('backbone-events-standalone');
var CustomEvents = {};
BackboneEvents.mixin(CustomEvents);

module.exports = CustomEvents;
